import "./NavRight.scss";
import { Link } from "react-router-dom";

const NavRight = () => {
  return (
    <div className="nav-right">
      <div className="nav-right__lower">
        <Link to="/reviews" className="nav-right__link">
          REVIEWS
        </Link>
      </div>
      <div className="nav-right__upper">
        <Link to="/quotes" className="nav-right__link">
          QUOTES
        </Link>
      </div>
    </div>
  );
};

export default NavRight;
